<template>
  <div class="m-signedinInfo" v-if="emailAddress">You are signed in as <span class="bold">{{ emailAddress }}. </span>
    <a class="a-Link--Blue" v-bind:href="changeUserUrl" v-if="changeUserUrl">Sign in as someone else</a>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    emailAddress: state => state.user.emailAddress,
    changeUserUrl: state => state.globalstate.changeUserUrl
  })
}
</script>
<style lang="scss" scoped>
.m-signedinInfo {
  margin-bottom: 30px;
  @media all and (max-width: 768px) {
    span.bold {
      white-space: initial;
      word-break: break-word;
    }
    // add a line-break on mobile size to put 
    // `Sign in as someone else` on a another line
    span.bold::after {
      content: "\a";
      white-space: pre;
    }
  }
}
</style>



// WEBPACK FOOTER //
// SignIn.vue?f6773f5e